<template>
  <v-navigation-drawer
      app
      clipped
      fixed
      permanent
      floating
      v-model="drawer"
      width="360"
  >
    <!-- <v-list-tile
      class="custom-tile createFolder"
      @click="customFolderDialog = true"
      :class="{'customFoldersLength' : this.customFolders.length === 5}"
    >
      <v-list-tile-action class="ml-4">
        <v-icon
          size="24"
          :class="{'customFoldersLength' : this.customFolders.length === 5}"
        >
          mdi-plus
        </v-icon>
      </v-list-tile-action>
      <v-list-tile-title>
        Criar Pasta
      </v-list-tile-title>

    </v-list-tile> -->
    <div class="context-menu-side-bar" style="display:none">
      <div @click="getDialogDelete()">Remover</div>
    </div>

    <v-treeview
        class="mt-3"
        :items="items"
        activatable
        item-key="id"
        item-text="none"
    >

      <template v-slot:prepend="{ item }">
        <v-list-tile
          class="custom-tile"
          :class="[{'blue white--text': activeRoute === item.name && activeRoute !== 'CustomFolder'},
                      {'mt-4': item.name === 'Archived'},
                      {'blue white--text': item.name === 'CustomFolder' && item.id === activateRouteCustom},
                      {'folder-custom-name': item.name === 'CustomFolder'},
                      {'customFoldersLength': item.name === 'CreateCustomFolder' && customFolders.length >= 5}]"
          @click="{item.name === 'CreateCustomFolder'? showCustomFolderDialog() : goToRoute(item.name, item.id)}"
          @dragover.prevent
          @drop="dropFolder(item.id, $event)"
          @dragenter="dragEnter" @dragleave="dragLeave"
          v-b-tooltip.hover :title="`${item.name === 'CustomFolder' ? item.label : item.name === 'CreateCustomFolder' ? 'Permitido criar até 5 pastas' : ''}`"
          @contextmenu.prevent="`${ item.name === 'CustomFolder' ? showMenu($event, item.id) : ''}`"
        >
          <v-list-tile-action>
            <v-icon
                size="24"
                :color="activeRoute === item.name && activeRoute !== 'CustomFolder' ? 'white' : ''"
                :class="[{'customIcon': activateRouteCustom === item.id}]"
            >
              {{ item.ico }}
            </v-icon>
          </v-list-tile-action>
          <v-list-tile-title>{{ item.label }}</v-list-tile-title>
        <span
          class="counter"
          v-if="item.name === 'Inbox' && inboxCounter >= 0"
        >
          {{ (inboxCounter < 1000) ? inboxCounter : '999+' }}
        </span>
        <span
          v-else-if="item.name ==='CreateCustomFolder'"
          class="counter createFolder"
        >
          <custom-folder-dialog
            :show="customFolderDialog"
            @close="customFolderDialog = false"
            @created-folder="getAllCustomFolders"
          />
        </span>
          <span class="counter" v-else-if="item.name === 'Unreceived' && unreceivedCounter >= 0">
            {{ (unreceivedCounter < 1000) ? unreceivedCounter : '999+' }}
          </span>
          <span class="counter" :key="item.id" v-else-if="item.name === 'CustomFolder'">
            {{ item.counter < 1000 ? item.counter : '999+' }}
          </span>
          <span class="counter" v-else-if="item.name === 'Pending'  && pendingCounter >= 0">
            {{ pendingCounter < 1000 ? pendingCounter : '999+' }}
          </span>
          <span class="counter" v-else-if="item.name === 'Sent' && foldersCount.sent >= 0">
            {{ foldersCount.sent < 1000 ? foldersCount.sent : '999+' }}
          </span>
          <span class="counter" v-else-if="item.name === 'Archived' && foldersCount.archived >= 0">
            {{ (foldersCount.archived < 1000) ? foldersCount.archived : '999+' }}
          </span>
        </v-list-tile>
      </template>

    </v-treeview>


    <v-list
        class="mt-4 filter-folder-types"
        v-if="types.length > 0 && activeRoute === 'Inbox'"
    >
      <v-subheader
          class="mx-4 px-3 grey--text text--lighten-1"
      >
        Filtros por Tipo (Caixa de Entrada)
      </v-subheader>
      <v-list-tile
          class="folder-type-link"

          v-for="(folderType, index) in types"
          :key="index"
          @click="applyFolderTypeFilter(folderType)"
      >
        <v-list-tile-action class="ml-4">
          <v-icon size="18" color="grey">mdi-folder</v-icon>
        </v-list-tile-action>
        <v-list-tile-title class="normal-text">{{ folderType.name }} ({{ folderType.total }})</v-list-tile-title>
      </v-list-tile>
    </v-list>

    <v-dialog
      v-model="dialogDeleteFolder"
      persistent max-width="450">
      <v-card>
        <v-card-title class="headline red darken-2 white--text" primary-title>Atenção!</v-card-title>
        <v-card-text>Você tem certeza que deseja excluir essa pasta? Após essa ação não terá como desfazer.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" flat @click="deleteCustomFolder()">Confirmar</v-btn>
          <v-btn color="red darken-1" flat @click="close()">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-navigation-drawer>
</template>

<script>
import CustomFolderDialog from "../../../components/folder/new-custom-folder/NewCustomFolderDialog.vue";
import customFolderService from "../../../services/CustomFolderService";
import draggable from "vuedraggable";
import { mapGetters } from "vuex";

export default {
  name: "FolderSidebar",
  components: {
    CustomFolderDialog,
    draggable
  },
  data() {
    return {
      drawer: true,
      activateRouteCustom: "",
      activeRoute: "",
      types: [],
      items: [
        {
          id: "inbox",
          name: "Inbox",
          label: "Caixa de Entrada",
          ico: "mdi-inbox",
          children: [
            {
              id: "CreateCustomFolder",
              name: "CreateCustomFolder",
              label: "Criar Pasta",
              ico: "mdi-plus"
            },
            {
              id: "unreceived",
              name: "Unreceived",
              label: "Não Recebidos",
              ico: "mdi-file-cancel"
            }
          ]
        },
        {
          id: "pending",
          name: "Pending",
          label: "Pendências",
          ico: "mdi-clock-alert-outline"
        },
        {
          id: "sent",
          name: "Sent",
          label: "Enviados",
          ico: "mdi-send"
        },
        {
          id: "archived",
          name: "Archived",
          label: "Arquivados",
          ico: "mdi-archive"
        }
      ],
      customFolderDialog: false,
      customFolders: [],
      selected: null,
      dialogDeleteFolder: false,
      folderId: null,
      showIcon: false
    };
  },
  created() {
    document.addEventListener("click", this.closeContextMenu);
    document.addEventListener("dragenter", this.dragEnter);
    document.addEventListener("dragleave", this.dragLeave);
  },
  destroyed() {
    document.removeEventListener("click", this.closeContextMenu);
    document.removeEventListener("dragenter", this.dragEnter);
    document.addEventListener("dragleave", this.dragLeave);
  },
  mounted() {
    this.activeRoute = this.$router.currentRoute.name;
    this.getAllCustomFolders();
  },
  methods: {
    goToRoute(routeName, id = null) {
      this.$router.push({ name: routeName, params: { id: id } });
      this.activeRoute = routeName;
      this.activateRouteCustom = id;
    },
    applyFolderTypeFilter(folderType) {
      this.$store.dispatch("setActiveFolderFilterType", folderType);
      this.$store.dispatch("setFolderTypeSelected", folderType);
    },
    getAllCustomFolders(folderIdDeleted = null) {
      const inbox = this.items.find(({ name }) => name === "Inbox");
      customFolderService.getAllCustomFolders().then(({ data }) => {
        this.customFolders = data;
        for (let i = 0; i < data.length; i++) {
          var customFoldersObj = {
            name: "CustomFolder",
            label: data[i].name,
            ico: "mdi-folder",
            id: data[i].id,
            counter: data[i].folder_count
          };

          // Se existe um CustomFolder deletado, remove da lista de children do Inbox
          if (folderIdDeleted) {
            const index = inbox.children.findIndex(
              children => children.id === folderIdDeleted
            );
            inbox.children.splice(index, 1);
          }

          // Se já existe CustomFolder na lista de children do Inbox, não adiciona novamente
          if (!inbox.children.some(child => child.id === customFoldersObj.id)) {
            inbox.children.push(customFoldersObj);
          }
        }
      });
    },
    getDialogDelete() {
      this.dialogDeleteFolder = true;
      this.closeContextMenu();
    },
    deleteCustomFolder() {
      customFolderService
        .deleteCustomFolder(this.folderId)
        .then(() => {
          this.getAllCustomFolders(this.folderId);
          this.dialogDeleteFolder = false;
        })
        .catch(err => {
          this.$store.dispatch("toggleSnackbar", {
            show: true,
            color: "error",
            message: err.response.data.error,
            messageIcon: "mdi-alert-outline"
          });
        });
      this.$router.push({ name: "Inbox" });
    },
    close() {
      this.dialogDeleteFolder = false;
    },
    dropFolder(targetFolderId, event) {
      const folderId = this.draggingFolderId;
      if (folderId) {
        customFolderService
          .addFolderToCustomFolder(targetFolderId, folderId)
          .then(() => {
            this.$store.dispatch("toggleSnackbar", {
              show: true,
              color: "success",
              message: "Pasta movida com sucesso!",
              messageIcon: "mdi-check-circle-outline"
            });

            const inbox = this.items.find(({ name }) => name === "Inbox");
            inbox.children.forEach(child => {
              if (child.id === targetFolderId) {
                child.counter++;
              }
            });
          })
          .catch(err => {
            this.$store.dispatch("toggleSnackbar", {
              show: true,
              color: "error",
              message: err.response.data.error,
              messageIcon: "mdi-alert-outline"
            });
          })
          .finally(() => {
            this.$store.commit("clearDragDrop");
            event.target.classList.remove("hovered");
          });
      }
    },
    dragEnter(event) {
      if (event.target.classList.contains("v-list__tile__title")) {
        event.target.classList.add("hovered");
      }
    },
    dragLeave(event) {
      event.target.classList.remove("hovered");
    },
    showCustomFolderDialog() {
      if (this.customFolders.length < 5) {
        this.customFolderDialog = true;
      }
    },
    showMenu(event, folderId) {
      this.folderId = folderId;

      const contextMenu = document.querySelector(".context-menu-side-bar");

      contextMenu.style.display = "block";
      const offsetX = 0;
      const offsetY = 50;
      contextMenu.style.left = event.clientX - offsetX + "px";
      contextMenu.style.top = event.clientY - offsetY + "px";
    },
    closeContextMenu(event) {
      const contextMenu = document.querySelector(".context-menu-side-bar");
      if (contextMenu) {
        contextMenu.style.display = "none";
      }
    }
  },
  computed: {
    ...mapGetters(["draggingFolderId"]),
    foldersCount() {
      return this.$store.getters.foldersCount;
    },
    inboxCounter() {
      return this.foldersCount.inbox;
    },
    unreceivedCounter() {
      return this.foldersCount.unreceived;
    },
    folderTypes() {
      return this.$store.getters.folderTypes;
    },
    pendingCounter() {
      return this.foldersCount.signatures + this.foldersCount.revisions;
    },
    callCounter() {
      return this.$store.getters.callCounter;
    }
  },
  watch: {
    folderTypes(val) {
      if (val.length > 0) {
        this.types = val;
      }
    },
    $route({ name }) {
      this.activeRoute = name;
    },
    callCounter(newVal) {
      const folderId = this.$store.getters.folderIdCounter;
      const inbox = this.items.find(({ name }) => name === "Inbox");
      inbox.children.forEach(child => {
        if (child.id === folderId) {
          child.counter--;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.counter {
  min-width: 21px;
  text-align: end;
  margin-left: 14px;
  font-weight: 500;
  font-size: 14px;
}

.createFolder {
  margin-top: 2rem;
}

.custom-tile {
  margin-right: 3rem;
  border-top-right-radius: 50px;
  border-bottom-right-radius: 50px;
  overflow: hidden;
  min-width: 250px;
  max-width: 250px;
}

.custom-tile-action {
  margin-left: 1rem;
  padding-left: 1rem;
  width: 100%;
}

.customIcon {
  color: white;
}

.custom-tile:hover {
  background: rgba(0, 0, 0, 0.12);
  margin-right: 3rem;
  border-top-right-radius: 50px;
  border-bottom-right-radius: 50px;
  overflow: hidden;
}

.v-treeview > .v-treeview-node--leaf {
  padding-left: 0 !important;
}

.folder-custom-name {
  overflow: hidden;
  text-overflow: ellipsis;
  width: 35ch;
  white-space: nowrap;
}

.folder-type-link {
  // height: 32px;
  .v-list__tile__action {
    min-width: 36px;
  }
}

.normal-text {
  font-weight: normal;
}

.v-treeview-node__root {
  padding-left: 0 !important;
}

.v-treeview-node__label {
  display: none !important;
}

.customFoldersLength {
  color: rgb(179, 179, 179);
  pointer-events: none;
}

.context-menu-side-bar {
  position: absolute;
  background: #fff;
  border: 1px solid #ccc;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  cursor: pointer;
}

.context-menu-side-bar div {
  padding: 8px 12px;
}

.context-menu-side-bar div:hover {
  background: #cecdcd;
}

.hovered {
  background-color: #005ece;
  border-top-right-radius: 50px;
  border-bottom-right-radius: 50px;
  padding-top: 8px;
  padding-bottom: 35px;
}
</style>



// WEBPACK FOOTER //
// src/components/folder/list/FolderSidebar.vue